import React from 'react';

import { TruncatedText } from 'ui-components/components/truncated-text/index';

/**
 * @param {object} props
 * @param {import('../transaction-history').IdCell} props.cell
 * @returns {JSX.Element}
 */
export const IdentifierCell = ({ cell }) => {
  const allIds = cell.value?.join(', ');
  return allIds ? <TruncatedText value={allIds} /> : <>&mdash;</>;
};
